import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { server } from '../config'
import { IWebMenu, WebMenuTypeEnum } from '../interfaces/webMenu'
import { mapWebMenus, prepareMap } from '../utils/webmenus'

const fetcher = (url: string): Promise<any> => {
  const options: RequestInit = {
    method: 'GET',
  }
  return fetch(url, options).then((r) => r.json())
}

const useFetchWebmenus = () => {
  const [state, setState] = useState<{ [key: string]: IWebMenu }>({})
  const { data, error } = useSWR<IWebMenu[]>(`${server}/webmenus`, fetcher)
  useEffect(() => {
    if (data) {
      const updatedData = prepareMap(data)
      const map = mapWebMenus(updatedData)
      setState(map)
    }
  }, [data])
  return state
}

export default useFetchWebmenus
